import { Link } from "react-router-dom";
 function ExperiencesCovid() {

return(
    <div className="appendBottom20">
    <div
      className="covidCard"
      style={{
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="covidCard__header">
        <p className="latoBlack font22 blackText appendBottom3">
          <font color="#000000">Important Information</font>
        </p>
        <p className="font16 lineHight20 appendBottom15">
          <font color="#000000">
            <br />
            We request you to keep track of latest guideline
            and restrictions.
          </font>
        </p>
      </div>
      <div className="covidCard__desc">
        <div className="covidCard__descLeft">
          <p
            className="makeFlex hrtlCenter appendBottom8"
            style={{ marginTop: 0 }}
          >
            <span className="appendRight10">
              <img
                width="20"
                src="images/shield.png"
                alt=""
              />
            </span>{" "}
            <span className="latoBlack font16 blackText 111">
              <font color="#00dc7f">
                <b>My</b>
              </font>
              <font color="#000000">
                <b>Safety</b>
              </font>
              <font color="#000000">
                {" "}
                - Safe and Hygienic Stays
              </font>
            </span>
          </p>
          <ul
            className="covidCard__list2"
            style={{ marginTop: 10 }}
          >
            <li>
              <span className="appendRight5">
                {" "}
                <img
                  width="14"
                  src="images/Green.png"
                  alt=""
                />
              </span>
              <span className="">
                <font color="#000000">
                  Sanitized Environment
                </font>
              </span>
            </li>
            <li>
              <span className="appendRight5">
                {" "}
                <img
                  width="14"
                  src="images/Green.png"
                  alt=""
                />
              </span>
              <span className="">
                <font color="#000000">Trained Staff</font>
              </span>
            </li>
            <li>
              <span className="appendRight5">
                {" "}
                <img
                  width="14"
                  src="images/Green.png"
                  alt=""
                />
              </span>
              <span className="">
                <font color="#000000">Safe Practices</font>
              </span>
            </li>
            <li>
              <span className="appendRight5">
                {" "}
                <img
                  width="14"
                  src="images/Green.png"
                  alt=""
                />
              </span>
              <span className="">
                <font color="#000000">Safe Dining</font>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)}
export default ExperiencesCovid;